import { render, staticRenderFns } from "./PageEducatorInstitutionTeacherRead.vue?vue&type=template&id=68d4bf0c&scoped=true&"
import script from "./PageEducatorInstitutionTeacherRead.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionTeacherRead.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionTeacherRead.vue?vue&type=style&index=0&id=68d4bf0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d4bf0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
